// All form fields derived from FEwB Alumni Questionnaire

export const TITLE_OPTIONS = ['Mr', 'Miss', 'Mrs', 'Professor', 'Dr', 'Other'];

export const FLUENCY_OPTIONS = ['Native', 'Fluent', 'Proficient', 'Basic', 'None'];

export const EDUCATION_OPTIONS = ["Master's Degree", "PhD", "Post-Doc"];

export const GRADUATION_YEARS = Array.from({ length: 12 }, (_, i) => String(2015 + i));

export const SECTOR_OPTIONS = [
  "Government (Ministry or Public Health Institute)",
  "International NGO (INGO)",
  "Local NGO",
  "Academic/Research Institution",
  "United Nations Agency (e.g., WHO, UNICEF)",
  "African Union Agency (e.g., Africa CDC, AU IBAR, AU NEPAD)",
  "Regional Economic Community (e.g., IGAD, EAC, COMESA)",
  "Private Sector",
  "Consultant (Self-employed)",
  "Other"
];

export const AVAILABILITY_OPTIONS = ['Yes', 'No', 'Depends on circumstances'];

export const DEPLOYMENT_DURATION = [
  { key: 'shortTerm', label: 'Short-term (up to 2 weeks)' },
  { key: 'mediumTerm', label: 'Medium-term (2 weeks to 2 months)' },
  { key: 'longTerm', label: 'Long-term (2–6 months)' },
  { key: 'extended', label: 'Extended (6+ months)' },
];

export const NOTICE_PERIOD_OPTIONS = [
  'Immediately (within 24–48 hours)',
  '1 week',
  '2 weeks',
  '1 month',
  'More than 1 month',
];

export const CONTINENTS = [
  'Africa',
  'Asia',
  'Europe',
  'North America',
  'South America',
  'Oceania',
  'Antarctica',
];

export const SKILL_RATING_SCALE = '1=Basic, 2=Limited, 3=Proficient, 4=Highly Proficient, 5=Expert';

export const FIELD_EPI_SKILLS = [
  { key: 'surveillance', label: 'i. Disease Surveillance Systems (design, implementation, evaluation)' },
  { key: 'outbreakInvestigation', label: 'ii. Outbreak Investigation (all steps, including field work)' },
  { key: 'caseDefinition', label: 'iii. Case Definition Development' },
  { key: 'lineListing', label: 'iv. Line Listing/Database Management (Excel, Access, REDCap)' },
  { key: 'descriptiveEpi', label: 'v. Descriptive Epidemiology (person, place, time)' },
  { key: 'analyticEpi', label: 'vi. Analytic Epidemiology (case-control, cohort studies)' },
  { key: 'dataCollectionDesign', label: 'vii. Data Collection Tool Design (questionnaires, forms)' },
  { key: 'epiInfo', label: 'viii. Data Analysis using Epi Info' },
  { key: 'rSoftware', label: 'ix. Data Analysis using R' },
  { key: 'stata', label: 'x. Data Analysis using Stata' },
  { key: 'spss', label: 'xi. Data Analysis using SPSS' },
  { key: 'sas', label: 'xii. Data Analysis using SAS' },
  { key: 'otherSoftware', label: 'xiii. Data Analysis using other software' },
  { key: 'epicCurve', label: 'xiv. Epidemic Curve Construction and Interpretation' },
  { key: 'gis', label: 'xv. Mapping/GIS for Epidemiology (e.g., QGIS, ArcGIS)' },
  { key: 'reportWriting', label: 'xvi. Report Writing (technical reports, scientific papers)' },
  { key: 'pubHealthComm', label: 'xvii. Public Health Communication (briefings, presentations)' },
  { key: 'rcce', label: 'xviii. Risk Communication and Community Engagement (RCCE)' },
  { key: 'contactTracing', label: 'xix. Contact Tracing Methodologies' },
  { key: 'ipc', label: 'xx. Infection Prevention and Control (IPC) in outbreaks' },
  { key: 'epidemicIntelligence', label: 'xxi. Epidemic Intelligence/Outbreak Detection' },
  { key: 'vpd', label: 'xxii. Vaccine Preventable Diseases Surveillance/Response' },
  { key: 'zoonotic', label: 'xxiii. Zoonotic Disease Epidemiology/One Health Approach' },
  { key: 'envHealth', label: 'xxiv. Environmental Health Epidemiology' },
  { key: 'ncd', label: 'xxv. Non-Communicable Disease (NCD) Epidemiology' },
  { key: 'mchEpi', label: 'xxvi. Maternal, Child, and Reproductive Health Epidemiology' },
];

export const PROJECT_MGMT_SKILLS = [
  { key: 'projectPlanning', label: 'i. Project Planning and Design (e.g., logical frameworks)' },
  { key: 'budgetMgmt', label: 'ii. Budget Development and Management' },
  { key: 'teamLeadership', label: 'iii. Team Leadership and Coordination' },
  { key: 'stakeholder', label: 'iv. Stakeholder Engagement and Management' },
  { key: 'grantWriting', label: 'v. Grant Writing and Proposal Development' },
  { key: 'donorReporting', label: 'vi. Report Writing for Donors/Funders' },
  { key: 'resourceMobilization', label: 'vii. Resource Mobilization' },
  { key: 'riskMgmt', label: 'viii. Risk Management (project-level)' },
];

export const ME_SKILLS = [
  { key: 'meFramework', label: 'i. M&E Framework Development (logical models, M&E plans)' },
  { key: 'indicatorDev', label: 'ii. Indicator Development and Tracking' },
  { key: 'dataQuality', label: 'iii. Data Quality Assurance' },
  { key: 'evalDesign', label: 'iv. Evaluation Design (process, outcome, impact evaluations)' },
  { key: 'quantEval', label: 'v. Quantitative Evaluation Methods' },
  { key: 'qualEval', label: 'vi. Qualitative Evaluation Methods' },
  { key: 'tors', label: 'vii. Developing Terms of Reference (ToRs) for evaluations' },
  { key: 'evalReporting', label: 'viii. Reporting Evaluation Findings' },
];

export const GHS_SKILLS = [
  { key: 'jee', label: 'i. Joint External Evaluations (JEEs) – participation or leadership' },
  { key: 'aar', label: 'ii. After Action Reviews (AARs) – participation or leadership' },
  { key: 'jap', label: 'iii. Joint Action Planning (JAP) processes' },
  { key: 'ihr', label: 'iv. International Health Regulations (IHR) Core Capacities understanding' },
  { key: 'eoc', label: 'v. Emergency Operations Center (EOC) Functionality' },
  { key: 'prepPlanning', label: 'vi. Public Health Emergency Preparedness Planning' },
  { key: 'simExercises', label: 'vii. Simulation Exercises/Drills (design, conduct, evaluation)' },
  { key: 'amr', label: 'viii. Antimicrobial Resistance (AMR) Surveillance/Response' },
  { key: 'chemRad', label: 'ix. Chemical/Radiological Event Preparedness/Response' },
  { key: 'biosafety', label: 'x. Biosafety and Biosecurity Principles' },
];

export const INCIDENT_SKILLS = [
  { key: 'incidentCommand', label: 'i. Incident Command Leadership' },
  { key: 'responsePillar', label: 'ii. Response Pillar Command/Leadership' },
  { key: 'outbreakCoord', label: 'iii. Outbreak Response Coordination' },
  { key: 'partnerCoord', label: 'iv. Partner Coordination' },
  { key: 'incidentResource', label: 'v. Resource Mobilization' },
  { key: 'resourceMapping', label: 'vi. Resource Mapping' },
];

export const LEADERSHIP_SKILLS = [
  { key: 'mentorship', label: 'i. Mentorship and Coaching' },
  { key: 'curriculum', label: 'ii. Curriculum Development for Training Programs' },
  { key: 'facilitation', label: 'iii. Facilitation of Workshops/Training Sessions' },
  { key: 'publicSpeaking', label: 'iv. Public Speaking and Presentation Skills' },
  { key: 'strategicPlanning', label: 'v. Strategic Planning' },
  { key: 'policyDev', label: 'vi. Policy Development and Advocacy' },
  { key: 'crossCultural', label: 'vii. Cross-cultural Communication and Sensitivity' },
];

export const HIGH_RISK_OPTIONS = ['Yes', 'No', 'Depends on the specific risk assessment'];

export const DEFAULT_FORM_VALUES = {
  // Section A
  title: '',
  titleOther: '',
  firstName: '',
  surname: '',
  preferredEmail: '',
  alternativeEmail: '',
  primaryPhone: '',
  secondaryPhone: '',
  currentCountry: '',
  nationality: '',
  languages: {
    english: '',
    arabic: '',
    french: '',
    kiswahili: '',
    portuguese: '',
    chinese: '',
    russian: '',
    spanish: '',
    other: '',
    otherLanguage: '',
  },
  // Section B
  highestQualification: '',
  graduationYear: '',
  currentEmployer: '',
  currentRole: '',
  sector: '',
  sectorOther: '',
  yearsExperience: '',
  // Section C
  localDeployment: '',
  internationalDeployment: '',
  deploymentDuration: { shortTerm: false, mediumTerm: false, longTerm: false, extended: false },
  noticePeriod: '',
  noticePeriodOther: '',
  deploymentRestrictions: '',
  // Section D
  fieldEpiSkills: {},
  fieldEpiOtherSkills: '',
  otherSoftwareName: '',
  projectMgmtSkills: {},
  projectMgmtOtherSkills: '',
  meSkills: {},
  meOtherSkills: '',
  ghsSkills: {},
  ghsOtherSkills: '',
  incidentSkills: {},
  incidentOtherSkills: '',
  leadershipSkills: {},
  leadershipOtherSkills: '',
  // Section E
  diseasesExperience: '',
  workRegions: ['', '', '', '', ''],
  workContinents: [],
  humanitarianExperience: '',
  humanitarianContext: '',
  certifications: '',
  highRiskWillingness: '',
  additionalSkills: '',
  // Section F
  addReferences: '',
  references: [],
  // Consent
  consent: false,
};